export interface AnimeItem {
  id: string;
  title: string;
  cover: string;
  category: string;
  day: string;
  dayIndex: number;
  updateTime: string;
  latestEp: string;
  totalEp: string;
  status: "连载中" | "本周完结";
  desc: string;
  tags: string[];
  score: number;
  views: string;
  studio: string;
}

export interface NewsItem {
  id: string;
  title: string;
  cover: string;
  excerpt: string;
  date: string;
  tag: string;
  read: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const categories = [
  { name: "热血", icon: "ri-fire-line", count: 3 },
  { name: "奇幻", icon: "ri-sparkling-2-line", count: 2 },
  { name: "恋爱", icon: "ri-heart-line", count: 2 },
  { name: "悬疑", icon: "ri-search-eye-line", count: 2 },
  { name: "搞笑", icon: "ri-emotion-happy-line", count: 1 },
  { name: "日常", icon: "ri-cup-line", count: 1 },
  { name: "科幻", icon: "ri-rocket-line", count: 1 },
];

export const weekDays = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];

export const animeList: AnimeItem[] = [
  {
    id: "xinghai",
    title: "星海战记",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20key%20visual%20of%20a%20young%20pilot%20standing%20inside%20a%20mecha%20spaceship%20cockpit%2C%20starry%20galaxy%20nebula%20glowing%20through%20the%20window%2C%20warm%20orange%20and%20teal%20accent%20lights%2C%20cinematic%20composition%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-xinghai&orientation=portrait",
    category: "科幻",
    day: "周六",
    dayIndex: 5,
    updateTime: "23:30",
    latestEp: "第24话",
    totalEp: "全26话",
    status: "连载中",
    desc: "少年飞行员阿澈意外觉醒星海之力，驾驶最后一台原型机甲冲出地球圈，在无边星河中寻找失落的故乡坐标。热血的太空战斗与细腻的同伴羁绊交织，本季度最燃的科幻巨制。",
    tags: ["机甲", "太空", "热血", "成长"],
    score: 9.2,
    views: "1284万",
    studio: "星环动画",
  },
  {
    id: "huanyue",
    title: "幻月之森",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20key%20visual%20of%20a%20young%20elf%20girl%20standing%20in%20an%20enchanted%20golden%20forest%20with%20a%20huge%20glowing%20moon%2C%20warm%20fireflies%20and%20golden%20magic%20lights%2C%20mystical%20atmosphere%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-huanyue&orientation=portrait",
    category: "奇幻",
    day: "周二",
    dayIndex: 1,
    updateTime: "22:00",
    latestEp: "第16话",
    totalEp: "全24话",
    status: "连载中",
    desc: "森林女祭司小雾被选中守护千年幻月，却在一场夜祭中遇见来自人类王国的旅行者。两人跨越种族与国界，共同解开幻月即将陨落的古老预言。画风唯美，世界观浪漫治愈。",
    tags: ["魔法", "治愈", "奇幻冒险"],
    score: 8.9,
    views: "960万",
    studio: "月见制作",
  },
  {
    id: "lianse",
    title: "恋色协奏曲",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20key%20visual%20of%20a%20boy%20and%20a%20girl%20musicians%20playing%20on%20a%20school%20rooftop%20at%20sunset%2C%20warm%20pink%20and%20orange%20sky%2C%20cherry%20blossom%20petals%20floating%2C%20romantic%20atmosphere%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-lianse&orientation=portrait",
    category: "恋爱",
    day: "周四",
    dayIndex: 3,
    updateTime: "21:30",
    latestEp: "第11话",
    totalEp: "全13话",
    status: "连载中",
    desc: "钢琴少年与吉他少女因一场天台合奏结缘，两人在毕业季共同筹备校园音乐节。温柔细腻的情感描写配上原创配乐，甜而不腻，是本季治愈系恋爱的口碑之作。",
    tags: ["校园", "音乐", "青春", "纯爱"],
    score: 9.0,
    views: "812万",
    studio: "音符社",
  },
  {
    id: "wuye",
    title: "午夜侦探社",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20key%20visual%20of%20a%20young%20detective%20holding%20a%20magnifying%20glass%20in%20a%20rainy%20midnight%20city%20alley%2C%20warm%20lantern%20glow%20against%20dark%20teal%20night%2C%20moody%20film%20noir%20anime%20style%2C%20high%20quality%20digital%20anime%20art%2C%20no%20text&width=480&height=640&seq=cover-wuye&orientation=portrait",
    category: "悬疑",
    day: "周三",
    dayIndex: 2,
    updateTime: "22:30",
    latestEp: "第13话",
    totalEp: "全18话",
    status: "连载中",
    desc: "只在午夜营业的侦探社，专门接手城市里无法立案的离奇案件。冷静的少年侦探与毒舌的搭档少女，在一次次案件背后逼近一个关于整座城市的真相。悬念层层递进，烧脑过瘾。",
    tags: ["推理", "都市", "悬疑"],
    score: 8.7,
    views: "743万",
    studio: "夜灯映画",
  },
  {
    id: "yuanqi",
    title: "元气食堂",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20key%20visual%20of%20cheerful%20high%20school%20students%20cooking%20together%20in%20a%20bright%20sunny%20school%20kitchen%2C%20warm%20yellow%20and%20orange%20tones%2C%20steaming%20food%20and%20fresh%20vegetables%2C%20energetic%20slice%20of%20life%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-yuanqi&orientation=portrait",
    category: "日常",
    day: "周一",
    dayIndex: 0,
    updateTime: "20:00",
    latestEp: "第9话",
    totalEp: "全12话",
    status: "连载中",
    desc: "落魄的学校食堂被五位性格迥异的学生接手，从一碗普通的味噌汤开始，他们用美食治愈了一个又一个同学的烦恼。轻松搞笑又不失温暖，看完每一话都想来一碗热腾腾的饭。",
    tags: ["美食", "治愈", "校园"],
    score: 8.8,
    views: "635万",
    studio: "炊烟动画",
  },
  {
    id: "nixi",
    title: "逆袭高校",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20key%20visual%20of%20a%20determined%20young%20student%20with%20fist%20raised%20in%20a%20sunlit%20gymnasium%2C%20warm%20orange%20dramatic%20lighting%2C%20energetic%20sports%20anime%20composition%2C%20dust%20particles%20in%20light%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-nixi&orientation=portrait",
    category: "热血",
    day: "周五",
    dayIndex: 4,
    updateTime: "23:00",
    latestEp: "第18话",
    totalEp: "全24话",
    status: "连载中",
    desc: "垫底的问题少年转学进入体育名校，为了一句赌约加入无人问津的拳击部。从连败到逆袭，汗水与友情交织的青春热血物语，每一场比赛都让人握紧拳头。",
    tags: ["体育", "青春", "热血"],
    score: 9.1,
    views: "1102万",
    studio: "疾风制作",
  },
  {
    id: "shenyuan",
    title: "深渊回廊",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20key%20visual%20of%20a%20brave%20explorer%20entering%20a%20glowing%20ancient%20stone%20corridor%20with%20golden%20runes%20and%20torchlight%2C%20dramatic%20shadows%2C%20fantasy%20adventure%20atmosphere%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-shenyuan&orientation=portrait",
    category: "奇幻",
    day: "周日",
    dayIndex: 6,
    updateTime: "21:00",
    latestEp: "第20话",
    totalEp: "全24话",
    status: "连载中",
    desc: "地表之下埋藏着一座会移动的古老回廊，每层都藏着禁忌的机关与失落的文明。少女探险家率领小队一路向下，追寻深渊尽头封印的秘密。黑暗与希望的博弈令人欲罢不能。",
    tags: ["冒险", "黑暗", "宝藏"],
    score: 8.6,
    views: "588万",
    studio: "地心社",
  },
  {
    id: "xiari",
    title: "夏日约定",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20key%20visual%20of%20two%20silhouettes%20standing%20on%20a%20summer%20beach%20at%20golden%20sunset%2C%20ocean%20waves%20and%20warm%20orange%20sky%2C%20nostalgic%20romantic%20atmosphere%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-xiari&orientation=portrait",
    category: "恋爱",
    day: "周三",
    dayIndex: 2,
    updateTime: "20:30",
    latestEp: "第14话",
    totalEp: "全18话",
    status: "连载中",
    desc: "回到海边故乡的少年，重逢了童年最要好的玩伴。那年夏天没能说出口的约定，在这个暑假重新启程。细腻的夏日光影与青涩情愫，唤起每个人心里那段被海风吹过的回忆。",
    tags: ["夏日", "纯爱", "治愈"],
    score: 9.0,
    views: "821万",
    studio: "晴空制作",
  },
  {
    id: "jiaji",
    title: "机甲纪元",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20key%20visual%20of%20a%20giant%20mecha%20robot%20standing%20in%20a%20burning%20city%20street%20with%20orange%20explosion%20glow%2C%20dramatic%20battle%20anime%20style%2C%20smoke%20and%20sparks%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-jiaji&orientation=portrait",
    category: "科幻",
    day: "周六",
    dayIndex: 5,
    updateTime: "23:00",
    latestEp: "第22话",
    totalEp: "全26话",
    status: "连载中",
    desc: "地表文明崩塌后，残存的人类依靠古老的机甲军团重建秩序。驾驶机体第七次出击的少年机师，在废墟与机械的轰鸣中寻找停战的方法。宏大世界观，机械作画堪称天花板。",
    tags: ["机甲", "战争", "热血"],
    score: 8.5,
    views: "702万",
    studio: "铁翼社",
  },
  {
    id: "mengshou",
    title: "萌兽小食堂",
    cover: "https://readdy.ai/api/search-image?query=Cute%20kawaii%20chibi%20animal%20characters%20cooking%20together%20in%20a%20cozy%20warm%20pastel%20cafe%20kitchen%2C%20adorable%20food%20and%20desserts%2C%20soft%20warm%20colors%2C%20chibi%20anime%20style%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-mengshou&orientation=portrait",
    category: "搞笑",
    day: "周一",
    dayIndex: 0,
    updateTime: "19:30",
    latestEp: "第10话",
    totalEp: "全12话",
    status: "本周完结",
    desc: "森林深处有一家只接待小动物的深夜食堂，掌勺的是会说话的兔兔店长。一个个萌翻全场的无厘头小故事，配上让人垂涎的甜品，是解压放松的下饭神作。",
    tags: ["萌系", "轻松", "美食"],
    score: 8.4,
    views: "466万",
    studio: "毛茸茸社",
  },
  {
    id: "shijian",
    title: "时间旅行者",
    cover: "https://readdy.ai/api/search-image?query=Japanese%2520anime%2520key%25visual%2520of%2520a%2520traveler%2520stepping%2520through%2520a%2520glowing%2520golden%2520clockwork%2520portal%2520with%2520gears%2520and%2520steam%252C%2520warm%2520amber%2520light%252C%2520sci-fi%2520steampunk%2520anime%2520style%252C%2520high%2520quality%2520digital%2520anime%2520art%252C%2520clean%2520background%252C%2520no%2520text&width=480&height=640&seq=cover-shijian&orientation=portrait",
    category: "科幻",
    day: "周五",
    dayIndex: 4,
    updateTime: "22:00",
    latestEp: "第12话",
    totalEp: "全14话",
    status: "连载中",
    desc: "一只会走路的怀表将普通高中生卷入一场跨时空的冒险。每一次穿越都会改变一段历史，也改变他自己的命运。烧脑的时间悖论与温情内核，适合静下心来慢慢品味。",
    tags: ["穿越", "悬疑", "哲理"],
    score: 8.9,
    views: "689万",
    studio: "齿轮动画",
  },
  {
    id: "zhulin",
    title: "竹林剑客",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20anime%20key%20visual%20of%20a%20swordsman%20with%20a%20bamboo%20hat%20standing%20in%20a%20misty%20bamboo%20forest%2C%20warm%20golden%20sunlight%20rays%20through%20trees%2C%20flying%20leaves%2C%20high%20quality%20digital%20anime%20art%2C%20clean%20background%2C%20no%20text&width=480&height=640&seq=cover-zhulin&orientation=portrait",
    category: "热血",
    day: "周日",
    dayIndex: 6,
    updateTime: "21:30",
    latestEp: "第17话",
    totalEp: "全24话",
    status: "连载中",
    desc: "蒙尘的剑客隐居于竹林，只为守护一座无名小镇的安宁。当江湖风云再起，他不得不重新握剑。浓厚的中国水墨画风配上酣畅淋漓的武打场面，是国漫武侠的诚意之作。",
    tags: ["武侠", "江湖", "热血"],
    score: 8.8,
    views: "754万",
    studio: "青山动画",
  },
];

export const newsList: NewsItem[] = [
  {
    id: "news-1",
    title: "本周新番看点速览：五部高分神作更新进入白热化",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20studio%20scene%20with%20clapperboard%20and%20film%20reels%20under%20warm%20studio%20lights%2C%20behind%20the%20scenes%20animation%20production%2C%20vibrant%20warm%20tone%2C%20high%20quality%20digital%20anime%20art%2C%20no%20text&width=800&height=500&seq=news-jiban&orientation=landscape",
    excerpt: "本周妖精动漫网追番日历共收录 12 部连载作品，其中《星海战记》《逆袭高校》等多部高分神作更新进入剧情高潮，错过就要等下一周了。",
    date: "2026-08-18",
    tag: "更新速递",
    read: "2.3万",
  },
  {
    id: "news-2",
    title: "追番日历使用指南：三分钟搭建你的专属追番计划",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20desk%20with%20a%20weekly%20calendar%20and%20notebook%20planning%20schedule%2C%20warm%20morning%20light%2C%20cozy%20study%20scene%2C%20high%20quality%20digital%20anime%20art%2C%20no%20text&width=800&height=500&seq=news-calendar&orientation=landscape",
    excerpt: "还在担心错过心仪作品的最新一集？手把手教你用好妖精动漫网的追番日历，一键定位每周更新，让每一部作品都不再错过。",
    date: "2026-08-17",
    tag: "使用攻略",
    read: "1.8万",
  },
  {
    id: "news-3",
    title: "2026 夏季新番前瞻：三大热门题材扎堆回归",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20illustration%20of%20a%20colorful%20fireworks%20festival%20night%20sky%20over%20a%20city%2C%20summer%20anime%20celebration%2C%20warm%20golden%20and%20orange%20colors%2C%20festive%20atmosphere%2C%20high%20quality%20digital%20anime%20art%2C%20no%20text&width=800&height=500&seq=news-qianzhan&orientation=landscape",
    excerpt: "热血运动、奇幻冒险与校园恋爱三大题材在本季度集体发力，多部原创新作口碑炸裂，妖精动漫网为你梳理不容错过的夏季必追清单。",
    date: "2026-08-15",
    tag: "新番前瞻",
    read: "3.6万",
  },
];

export const faqList: FaqItem[] = [
  {
    q: "妖精动漫网上的动漫多久更新一次？",
    a: "妖精动漫网收录的作品均按官方播出节奏更新。通常连载作品每周固定更新一话，具体更新时间会显示在作品详情页和追番日历上。周一至周日每天都有新内容上线，更新后页面会第一时间同步。",
  },
  {
    q: "追番日历要怎么使用？",
    a: "进入追番日历页面后，你可以按周一至周日查看每一天正在更新的作品。今天有更新的作品会带醒目标记，点击任意作品卡片即可进入详情页直接观看最新话，非常方便。",
  },
  {
    q: "作品可以直接免费观看吗？",
    a: "可以。妖精动漫网提供的连载动漫、新番与完结动漫内容均可直接在线观看，无需任何费用。我们致力于为追番用户提供流畅、便捷的免费观看体验。",
  },
  {
    q: "在手机上访问效果如何？",
    a: "妖精动漫网采用完全响应式设计，在手机、平板和电脑上都能获得良好的浏览体验。手机端同样支持追番日历、搜索和分类筛选，随时随地都能追更。",
  },
  {
    q: "网站每天更新哪些内容？",
    a: "网站每天更新正在连载的作品最新话，同时汇总本周新番、热门连载与完结动漫的动态。首页的今日更新区块、追番日历以及本周新番页面会实时反映最新更新情况。",
  },
];

export const todayDay = "周二";